/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { gammaDependencies } from './dependenciesGamma.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createFactorial } from '../../factoriesAny.js';
export var factorialDependencies = {
  gammaDependencies: gammaDependencies,
  typedDependencies: typedDependencies,
  createFactorial: createFactorial
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFactorial.generated.js
// module id = 222
// module chunks = 0